const domain = "";
const api = domain + "/api/";
const urls = {

  industryNews: api + "industryNews", // 获取行业新闻接口
  companyActivity: api + "companyActivity", // 获取公司活动接口
  newsDetail: api + "newsDetail", // 获取资讯详情接口
  newsBanner: api + "newsBanner", // 获取详情顶部轮播图接口
  recruitmentBanner: api + "recruitmentBanner", // 获取招聘顶部轮播图接口
  contactInformation: api + "contactInformation", // 获取招聘联系方式接口
  recruitmentMsg: api + "recruitmentMsg", // 获取招聘信息接口
  factories: api + "factories", // 获取工厂信息接口
  contactUs: api + "contactUs", // 联系我们提交信息接口
  getBanner: api + "getBanner", // 获取轮播图接口
  getColumn: api + "getColumn", // 获取首页底部栏目接口
  getIntro: api + "getIntro", // 获取公司简介接口
  getCulture: api + "getCulture", // 获取企业文化接口
  getEmployee: api + "getEmployee", // 获取公司雇员接口
  getHistory: api + "getHistory", // 获取发展历程接口
  getHonor: api + "getHonor", // 获取荣誉资质接口
  getAboutUsBanner: api + "getAboutUsBanner", // 获取关于我们轮播图接口
  getProductTypeList: api + "getProductTypeList", // 获取产品分类列表接口
  getProductList: api + "getProductList", // 获取产品列表接口
  getProduct: api + "getProduct", // 获取产品接口
  getProductBanner: api + "getProductBanner", // 获取产品轮播图接口
  companyInfo: api + "companyInfo", // 获取公司信息接口
  // aaa: api + "aaa",                        //
  // aaa: api + "aaa",                        //

}
export default urls


//////////////////
// WEBPACK FOOTER
// ./utils/url.js
// module id = null
// module chunks = 